import styled from "styled-components";

export const Container = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  padding: 15px;
  border-radius: 5px;
`;

export const IconeContainerAtencao = styled.div`
  padding: 8px;

  svg {
    color: #ff9f42;
  }
`;

export const TextContainer = styled.div``;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: #ffefcc;
  border-radius: 5px;
  padding: 15px 10px;
  margin-top: 24px;
`;

export const ContainerAvisoAtualize = styled.div`
  color: ${({ theme }) => theme.colors.neutral.neutral60};
  font-size: 15px;
  margin-bottom: 24px;
  margin-top: 8px;
`;

export const ContainerInputs = styled.div``;

export const ContainerTituloInput = styled.div`
  color: ${({ theme }) => theme.colors.neutral.neutral60};
  margin-bottom: 2px;
  font-size: 15px;
`;
